import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const TooltipContent = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const TooltipIconContainer = styled(Box)`
  display: flex;
  align-items: center;
`

export const TooltipTitle = styled.span`
  ${({ theme }) => css`
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    color: ${theme.colors.secondary};
  `}
`

export const TooltipText = styled(TooltipTitle)`
  font-weight: 400;
`
